import { useT } from "../i18n/hooks.ts";
import { Dialog } from "./Dialog.tsx";

/** Warns before closing the project (TopBar.tsx's "Close project") while an AEMET download is still running — see aemetJobStore.ts. Confirming aborts every active job (App.tsx calls aemetJobStore.cancelAll()); there's no "keep it running in the background" option once the project itself closes, since nothing would be left to apply the result to. */
export function ConfirmCloseWithJobsDialog({
  onConfirm,
  onClose,
}: {
  onConfirm: () => void;
  onClose: () => void;
}) {
  const t = useT();
  return (
    <Dialog title={t("topbar.downloadInProgressWarningTitle")} onClose={onClose}>
      <p>{t("topbar.downloadInProgressWarningMessage")}</p>
      <div className="dialog-actions">
        <button
          className="button button-danger"
          onClick={() => {
            onConfirm();
            onClose();
          }}
        >
          {t("topbar.closeAnyway")}
        </button>
        <button className="button" onClick={onClose}>
          {t("common.cancel")}
        </button>
      </div>
    </Dialog>
  );
}
